import React from "react";

export default function BgModal() {
  return (
    <div className="fixed bg-black dark:bg-primaryLight opacity-80 inset-0 z-50">
      <div className="flex h-screen justify-center items-center"></div>
    </div>
  );
}
